import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IGenerationRules } from "./models";
import { generationRuleItems } from "./generation-rule.mock";

const translationPath = "page.4uDlist.generationRule.";

const GenerationRulePage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const columns: GridColDef<IGenerationRules>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "dataOrigin",
      headerName: t(translationPath + "data_origin") || "Data Origin",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value.name}
            tooltip={params.value.name}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<IGenerationRules>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<IGenerationRules>
      showDefaultMacroFilters={false}
      rows={generationRuleItems}
      columns={columns}
      title={t(translationPath + "generation_rules")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={t(translationPath + "search")}
      addButtonLabel={
        t(translationPath + "add_generation_rule") || "Add Generation Rule"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default GenerationRulePage;
